import { firstValueFrom, Observable, timeout } from 'rxjs';

export function waitForRequest<Type>(o: Observable<Type>): Promise<Type> {
	return firstValueFrom(o.pipe(timeout(15000))) as Promise<Type>;
}

